import React, { useState } from 'react';
import { Text, View, Image } from '@react-pdf/renderer';

import {// getICardSvc,
    getLogoSvc, getPrinciSignSvc
} from './progressReportSvc.js'
import { toast } from "react-toastify";
import { styles, styleCoSchoScore, styleSchoScore, styleFooter, styleHeaderLogo, styleHeaderAddress, styleHeaderName } from './reportCardStyles.js';


const HeaderLogoSection =  (props) => {
    const { headerSection } = props;
    const { logoUrl } = props;
    return (
        <View style={styleHeaderLogo.header_logo_section}>
            <View style={styleHeaderLogo.header_left}>
                <Image style={styleHeaderLogo.image1} src={logoUrl} />
            </View>
            <View style={styleHeaderLogo.header_center}>
                <Text style={styleHeaderLogo.school_header}>
                    {headerSection.school}<Text style={{ textTransform: "capitalize" }}></Text>
                    {/* GOLDEN ERA PUBLIC SCHOOL */}
                </Text>
                <Text style={styleHeaderLogo.school_header}>
                    {headerSection.address}<Text style={{ textTransform: "capitalize" }}></Text>
                    {/* MURADNAGAR, HISALI, U.P. – 201206 */}
                    </Text>
                <Text style={styleHeaderLogo.school_header}>
                    {"SESSION - " + headerSection.session}<Text style={{ textTransform: "capitalize" }}></Text>
                    {/* SESSION – 2023 - 24 */}
                    </Text>
            </View>
            <View style={styleHeaderLogo.header_right}>
                <Text></Text>
            </View>
        </View>
    )
};

const HeaderAddressSection =  (props) => {
    const { headerSection } = props;
    return (
        <View style={styleHeaderAddress.header_address_section}>
            <View style={styleHeaderAddress.address_left}>
            </View>
            <View style={styleHeaderAddress.address_center}>
                <View style={styleHeaderAddress.row_1}>
                    <Text style={styleHeaderAddress.text_address_label}>Address</Text>
                    <Text style={styleHeaderAddress.text_address_colon}>:</Text>
                    <Text style={styleHeaderAddress.text_address_value}>{headerSection.address}</Text>
                </View>
                <View style={styleHeaderAddress.row_1}>
                    <Text style={styleHeaderAddress.text_address_label}>Phone No. </Text>
                    <Text style={styleHeaderAddress.text_address_colon}>:</Text>
                    <Text style={styleHeaderAddress.text_address_value}>{headerSection.phone}</Text>
                </View>
                <View style={styleHeaderAddress.row_1}>
                    <Text style={styleHeaderAddress.text_address_label}>Affilliation No. </Text>
                    <Text style={styleHeaderAddress.text_address_colon}>:</Text>
                    <Text style={styleHeaderAddress.text_address_value}>{headerSection.affiliation}</Text>
                </View>
            </View>
            <View style={styleHeaderAddress.address_left}>
            </View>
        </View>
    )
}


const HeaderNameSection =  (props) => {
    const { headerName } = props;
    return (
        <View style={[styleHeaderName.header_text_section]}>
            <View style={[styleHeaderName.header_text]}>
                <Text style={styleHeaderName.headerNameText}>
                    {headerName.headerName}
                    {/* Report card */}
                </Text>
            </View>
            <View style={{ borderBottom: '2px solid #000', margin: '15px 10px 0 10px' }}>
            </View>
        </View>
    )
}


export { HeaderLogoSection, HeaderAddressSection, HeaderNameSection };